import { render, staticRenderFns } from "./SizeDemo.vue?vue&type=template&id=52ab803f&scoped=true&"
import script from "./SizeDemo.vue?vue&type=script&lang=js&"
export * from "./SizeDemo.vue?vue&type=script&lang=js&"
import style0 from "./SizeDemo.vue?vue&type=style&index=0&id=52ab803f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ab803f",
  null
  
)

export default component.exports